import { render, staticRenderFns } from "./ThereIsBookGotIsbn.vue?vue&type=template&id=35486156&scoped=true"
import script from "./ThereIsBookGotIsbn.vue?vue&type=script&lang=js"
export * from "./ThereIsBookGotIsbn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35486156",
  null
  
)

export default component.exports